import * as THREE from 'three';

const loader = new THREE.TextureLoader();
const cache = new Map<string, Promise<THREE.Texture>>();

/** Cached sRGB texture load. Rejects on 404 so callers can fall back. */
export function loadTex(url: string): Promise<THREE.Texture> {
  let p = cache.get(url);
  if (!p) {
    p = new Promise((resolve, reject) => {
      loader.load(
        url,
        (t) => {
          t.colorSpace = THREE.SRGBColorSpace;
          t.minFilter = THREE.LinearMipmapLinearFilter;
          t.generateMipmaps = true;
          t.anisotropy = 4;
          resolve(t);
        },
        undefined,
        () => {
          cache.delete(url);
          reject(new Error(`texture ${url}`));
        },
      );
    });
    cache.set(url, p);
  }
  return p;
}

export function preload(urls: string[]) {
  urls.forEach((u) => void loadTex(u).catch(() => undefined));
}

let glow: THREE.Texture | null = null;
/** Soft radial glow used for candle lights and flashes. */
export function glowTexture(): THREE.Texture {
  if (glow) return glow;
  const c = document.createElement('canvas');
  c.width = c.height = 128;
  const ctx = c.getContext('2d')!;
  const g = ctx.createRadialGradient(64, 64, 0, 64, 64, 64);
  g.addColorStop(0, 'rgba(255,255,255,1)');
  g.addColorStop(0.18, 'rgba(255,255,255,0.55)');
  g.addColorStop(0.45, 'rgba(255,255,255,0.14)');
  g.addColorStop(1, 'rgba(255,255,255,0)');
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, 128, 128);
  glow = new THREE.CanvasTexture(c);
  return glow;
}

export function blankTex(): THREE.DataTexture {
  const t = new THREE.DataTexture(new Uint8Array([0, 0, 0, 0]), 1, 1, THREE.RGBAFormat);
  t.needsUpdate = true;
  return t;
}
